<template>
    <div>
        <dx-grid
            :url="url"
            :columns="columns"
            :title="title"
            :onRowClicked="onRowClicked"
            navigationPath="onRowClicked"
            navigationField="onRowClicked"
            :beforeSetupGrid="beforeSetupGrid"
            ref="grid"
            :actions="actions"
            :expandedOptions="{
                enabled: true,
                template: 'vm-change-logs',
            }"
        >
        </dx-grid>
        <v-dialog v-model="approveDialog" max-width="400">
            <v-card class="pa-3">
                <v-card-title class="pl-0 pt-0 headline mb-2"
                    >Update VH Status</v-card-title
                >

                <v-layout row class="mb-2">
                    <div class="font-weight-medium mr-2">Account ID:</div>
                    <div>{{ clickedRow.accountID }}</div>
                </v-layout>
                <v-layout row class="mb-3">
                    <div class="font-weight-medium mr-2">Name:</div>
                    <div>
                        {{ clickedRow.firstNameH + " " + clickedRow.lastNameH }}
                    </div>
                </v-layout>
                <div class="font-weight-medium mr-2">Approved Status:</div>
                <div class="mb-2">
                    {{ clickedRow.approvedStatusY }}
                </div>

                <!-- <v-layout row class="mb-3" v-if="allowDownloadCards()">
                    <v-btn
                        class="mr-1"
                        color="success"
                        small
                        @click="printCards"
                        >Print Cards</v-btn
                    >
                    <v-btn class="" color="success" small @click="emailCards"
                        >Email Cards</v-btn
                    >
                </v-layout> -->

                <v-select
                    v-model="clickedRow.newVhStatus"
                    label="VH Status"
                    class="my-2"
                    :items="['OK', 'PROBLEM']"
                    hide-details
                    clearable
                ></v-select>

                <v-card-actions class="mr-0 mt-3">
                    <v-spacer></v-spacer>
                    <v-btn dark color="default" @click="approveDialog = false"
                        >Close</v-btn
                    >
                    <v-btn color="success" :loading="processing" @click="save"
                        >Save</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="emailCardsDialog" max-width="400">
            <v-card class="pa-2">
                <v-card-title class="headline">Email Cards</v-card-title>
                <v-text-field
                    class="px-3"
                    ref="email"
                    v-model="emailAddress"
                    :rules="emailRules"
                ></v-text-field>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        dark
                        color="default"
                        @click="emailCardsDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="emailing"
                        color="success"
                        @click="sendEmail"
                    >
                        Send
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { getDomain } from "../../utils/helpers.js";
export default {
    data: () => ({
        title: "VM Account Status",
        url: "",
        regID: "",
        actions: [],
        processing: false,
        approveDialog: false,
        emailCardsDialog: false,
        emailAddress: "",
        emailing: false,

        clickedRow: {
            accountID: "",
            newVhStatus: "",
        },

        emailRules: [
            (value) => !!value || "Required.",
            (value) => {
                const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return pattern.test(value) || "Invalid e-mail.";
            },
        ],

        columns: [
            {
                field: "accountID",
                label: "Account ID",
                format: "",
                //link: "Account View",
                //template: "link-cell-template",
                template: "link-action-cell-template",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
                showLink: (row) => {
                    return true;
                },
            },
            {
                field: "name",
                label: "Name",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "firstNameH",
                label: "First Name",
                format: "",
                visible: true,
                sortOrder: "asc",
                sortIndex: 1,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "lastNameH",
                label: "Last Name",
                format: "",
                visible: true,
                sortOrder: "asc",
                sortIndex: 0,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "homePhone",
                label: "Home Phone",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "cellPhone",
                label: "Cellphone",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "address1",
                label: "Address",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "father",
                label: "Father",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "shver",
                label: "Shver",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "emailAddress",
                label: "Email Address",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "regID",
                label: "Reg ID",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "kids",
                label: "Kids",
                format: "",
                type: "number",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "applyingKids",
                label: "Applying Kids",
                format: "",
                visible: true,
                type: "number",
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "vmStatus",
                label: "VM Status",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "vhStatus",
                label: "VH Status",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "vhIssuebyVM",
                label: "VH Issue by VM",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "isApproved",
                label: "VH Approved",
                visible: true,
                type: "boolean",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "lastCardAction",
                label: "Last Card Action",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Last Card Action Date",
                field: "lastCardActionDate",
                visible: true,
                type: "date",
                format: "MM/dd/yyyy hh:mm:ss a",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "approvedStatus",
                label: "Approved Status",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "approvedStatusY",
                label: "Approved Status",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
        ],
    }),
    created() {
        this.columns.find((c) => c.field == "accountID").linkAction = (
            account,
        ) => {
            this.toAccount(account);
        };
    },
    methods: {
        async beforeSetupGrid() {
            await this.loadRegID();

            const terms = await this.getTerms();

            this.actions.push({
                text: "Select Term",
                type: "select",
                values: terms,
                value: this.regID,
                onSelected: this.onTermSelected,
            });

            this.url = "vmAccountStatus?regID=" + this.regID;
        },
        async loadRegID() {
            this.regID = await this.$http.get("api/vmAccountStatus/getRegID");
        },
        async getTerms() {
            return await this.$http.get("api/allStudents/getRegTerms");
        },
        onTermSelected(value) {
            this.regID = value;

            this.url = "vmAccountStatus?regID=" + this.regID;

            this.$refs.grid.reloadDataSource(this.url);
        },
        onRowClicked(row) {
            this.clickedRow = row;
            this.clickedRow.newVhStatus = row.vhStatus;

            this.approveDialog = true;
        },
        toAccount(row) {
            this.$router.push({
                name: "Account View",
                params: {
                    id: row.accountID,
                },
                query: {
                    limitView: true,
                },
            });
        },
        allowDownloadCards() {
            return (
                this.clickedRow.approvedStatus &&
                this.clickedRow.approvedStatus.startsWith("Approved") &&
                (!this.clickedRow.newVhStatus ||
                    this.clickedRow.newVhStatus == "OK")
            );
        },
        printCards() {
            window.location =
                getDomain() +
                "/api/vmAccountStatus/downloadVmCards?accountID=" +
                this.clickedRow.accountID +
                "&user=" +
                this.$store.state.authentication.user;
        },
        emailCards() {
            this.emailAddress = this.clickedRow.emailAddress;

            this.emailCardsDialog = true;
        },
        async sendEmail() {
            if (!this.$refs.email.validate()) return;

            try {
                this.emailing = true;

                await this.$http.post(
                    "api/vmAccountStatus/emailCards?accountID=" +
                        this.clickedRow.accountID +
                        "&emailAddress=" +
                        this.emailAddress +
                        "&user=" +
                        this.$store.state.authentication.user,
                );

                this.$notify({
                    text: "Email Sent",
                    group: "notification",
                    type: "success",
                });

                this.emailing = false;

                this.emailCardsDialog = false;
                this.emailAddress = this.clickedRow.emailAddress;
            } catch (e) {
                this.emailing = false;
            }
        },
        async save() {
            // if (!this.clickedRow.newVhStatus) {
            //     return this.$notify({
            //         text: "VH Status Is Required",
            //         group: "notification",
            //         type: "error",
            //     });
            // }

            try {
                this.processing = true;

                await this.$http.post("api/vmAccountStatus/SaveVhStatus", {
                    user: this.$store.state.authentication.user,
                    accountID: this.clickedRow.accountID,
                    status: this.clickedRow.newVhStatus,
                });

                this.approveDialog = false;
                this.processing = false;

                this.$notify({
                    text: "Status Updated",
                    group: "notification",
                    type: "success",
                });

                this.$refs.grid.reloadGrid();
            } catch (e) {
                this.processing = false;
            }
        },
    },
};
</script>
<style></style>
